import styled from 'styled-components';
import { Form as FormikForm } from 'formik';
import { Styles } from '@gv/triage-components';

const { bodySemibold } = Styles.Font;

export const Text = styled.p`
  ${bodySemibold};
  min-width: 36px;
`;

export const Form = styled(FormikForm)`
  width: 100%;
`;
